import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
// import CustomTable from "components/Table/Table"

export const CompanySetup = () => {
  const [modal_large, setmodal_large] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_large() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }

  // const [totalSize, setTotalSize] = useState(3)

  // const data = {
  //   columns: [
  //     {
  //       text: "Company Name",
  //       dataField: "CompanyName",
  //       style: { width: "40%" },
  //     },
  //     {
  //       text: "Mobile Number",
  //       dataField: "MobileNumber",
  //       style: { width: "14%" },
  //     },
  //     {
  //       text: "Email Id",
  //       dataField: "EmailId",
  //       style: { width: "18%" },
  //     },
  //     {
  //       text: "City",
  //       dataField: "City",
  //       style: { width: "10%" },
  //     },
  //     {
  //       text: "State",
  //       dataField: "State",
  //       style: { width: "10%" },
  //     },
  //   ],
  //   rows: [
  //     {
  //       CompanyName: "Appegic",
  //       MobileNumber: "+91 9601615060",
  //       EmailId: "info@appegic.com",
  //       City: "Ahmadabad",
  //       State: "Gujarat",
  //     },
  //     {
  //       CompanyName: "Devstree Private Limited",
  //       MobileNumber: "+91 9904045044",
  //       EmailId: "info@devstree.com",
  //       City: "Ahmadabad",
  //       State: "Gujarat",
  //     },
  //     {
  //       CompanyName: "ManekTech",
  //       MobileNumber: "+91 8511428441",
  //       EmailId: "info@manektech.com",
  //       City: "Ahmadabad",
  //       State: "Gujarat",
  //     },
  //   ],
  // }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Company Setup | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="Company Setup"
            />
            <Col sm={6}>
              {/* <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    tog_large()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add Company
                </Button>
                <Modal
                  size="md"
                  isOpen={modal_large}
                  toggle={() => {
                    tog_large()
                  }}
                >
                  <div className="modal-header">
                    <h5 className="modal-title mt-0" id="myLargeModalLabel">
                      Company Setup
                    </h5>
                    <button
                      onClick={() => {
                        tog_large()
                      }}
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <AvForm className="needs-validation">
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              name="CompanyName"
                              label="Company Name"
                              placeholder="Company Name"
                              type="text"
                              errorMessage="Enter Company Name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="CompanyName"
                            />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              label="Mobile Number"
                              name="MobileNumber"
                              placeholder="Mobile Number"
                              type="text"
                              errorMessage="Enter Mobile Number"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="MobileNumber"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              label="Email Id"
                              name="email"
                              placeholder="Enter Valid Email Id"
                              type="email"
                              errorMessage="Invalid Email Id"
                              validate={{
                                required: { value: true },
                                email: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              label="Address"
                              name="Address"
                              placeholder="Address"
                              type="textarea"
                              errorMessage=" Please Enter Address"
                              className="form-control AddressTextarea"
                              validate={{ required: { value: true } }}
                              id="Address"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              label="City"
                              name="City"
                              placeholder="City"
                              type="text"
                              errorMessage=" Please provide a valid city."
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="City"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <FormGroup className="mb-3">
                            <AvField
                              label="State"
                              name="state"
                              placeholder="State"
                              type="text"
                              errorMessage="Please provide a valid state."
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="state"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Button color="primary" className="mt-3" type="submit">
                        Submit
                      </Button>{" "}
                      <Button
                        color="outline-primary"
                        className="mt-3"
                        onClick={() => {
                          tog_large()
                        }}
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </Button>
                    </AvForm>
                  </div>
                </Modal>
              </div> */}
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  {/* <CustomTable
                    keyField="userManagement"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  /> */}

                  <AvForm className="needs-validation">
                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            name="CompanyName"
                            label="Company Name"
                            placeholder="Company Name"
                            type="text"
                            errorMessage="Enter Company Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="CompanyName"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="Mobile Number"
                            name="MobileNumber"
                            placeholder="Mobile Number"
                            type="text"
                            errorMessage="Enter Mobile Number"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="MobileNumber"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="Email Id"
                            name="email"
                            placeholder="Enter Valid Email Id"
                            type="email"
                            errorMessage="Invalid Email Id"
                            validate={{
                              required: { value: true },
                              email: { value: true },
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="Address"
                            name="Address"
                            placeholder="Address"
                            type="textarea"
                            errorMessage=" Please Enter Address"
                            className="form-control AddressTextarea"
                            validate={{ required: { value: true } }}
                            id="Address"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="City"
                            name="City"
                            placeholder="City"
                            type="text"
                            errorMessage=" Please provide a valid city."
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="City"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="State"
                            name="state"
                            placeholder="State"
                            type="text"
                            errorMessage="Please provide a valid state."
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="state"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      color="outline-primary"
                      className="mt-3"
                      type="button"
                    >
                      Edit
                    </Button>{" "}
                    <Button color="primary" className="mt-3" type="submit">
                      Submit
                    </Button>{" "}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
